import { render, staticRenderFns } from "./Badge.vue?vue&type=template&id=63896eba&scoped=true"
import script from "./Badge.vue?vue&type=script&setup=true&lang=ts"
export * from "./Badge.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Badge.vue?vue&type=style&index=0&id=63896eba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63896eba",
  null
  
)

export default component.exports